$(function() {

	if (maintenanceModeDetected()) maintenanceModeBlockSetPosition();

	$(window).resize(function(event) {
		if (maintenanceModeDetected()) maintenanceModeBlockSetPosition();
	});

});


// Проверка включен ли режим разработки
function maintenanceModeDetected() {
	return (('.maintenance-mode-container').length > 0) ? true : false;
}


// Позиционирует информационный блок режима разработки
function maintenanceModeBlockSetPosition() {
	var container = $('.maintenance-mode-container'),
		containerHeight = container.outerHeight(),
		windowHeight = $(window).outerHeight();

	if (windowHeight > containerHeight) container.css('margin-top', parseInt((windowHeight - containerHeight) * 1 / 3));
	else container.removeAttr('style');
}